import BrandList from '../components/brand/List'
import BrandCreate from '../components/brand/Create'
import BrandUpdate from '../components/brand/Update'

export default [
  { name: 'BrandList', path: '/brands/', component: BrandList, props: { pageTitle: 'Brand List' } },
  { name: 'BrandCreate', path: '/brands/create', component: BrandCreate, props: { pageTitle: 'Brand Create' } },
  { name: 'BrandUpdate', path: '/brands/edit/:id', component: BrandUpdate, props: { pageTitle: 'Brand Update' } }
]
